import { Complement, ComplementGroup } from '@app/types';
import { getBRCurrencyFormat } from '@app/utils/formmater';
import React from 'react';
import { ComplementGroupSelectionType } from '..';
import classes from './styles.module.css';
import cls from 'classnames';
import AmountControl from './AmountControl';
import { useRestaurantContext } from '@app/pages/Restaurant/context';

type Props = {
  selected: boolean;
  complement: Complement;
  selectionType: ComplementGroupSelectionType;
  alreadySelectedMaxComplements: boolean;
  parentGroup: ComplementGroup;
  onSelect: (complement: Complement) => void;
  onMinusClick: (isHolding: boolean) => void;
  onPlusClick: (isHolding: boolean) => void;
};

export default function ComplementItem({
  selected,
  alreadySelectedMaxComplements,
  complement,
  selectionType,
  parentGroup,
  onPlusClick,
  onMinusClick,
  onSelect,
}: Props) {
  const { primaryColor } = useRestaurantContext();

  const isSelectType = selectionType === ComplementGroupSelectionType.Select;

  function dispatchOnSelect() {
    if (!isSelectType) return;
    onSelect(complement);
  }

  return (
    <div className={cls(classes.container, isSelectType && classes.complementClickalable)} onClick={dispatchOnSelect}>
      <div className={classes.info}>
        <h4>{complement.nome}</h4>
        {complement.descricao !== '' && <p>{complement.descricao}</p>}
        {complement.preco > 0 && <span>+ {getBRCurrencyFormat(complement.preco)}</span>}
      </div>
      {selectionType === ComplementGroupSelectionType.Select ? (
        <div
          className={classes.checkbox}
          style={{ backgroundColor: selected ? primaryColor : '#e8e8e8' }}
          data-cy={`select-complement-${complement.id}`}
        >
          {selected && <div className={classes.checkboxSelected} />}
        </div>
      ) : (
        <AmountControl
          value={complement.amount ?? 0}
          onMinusClick={onMinusClick}
          onPlusClick={onPlusClick}
          max={parentGroup.maximo}
          complementId={complement.id}
          plusButtonIsDisabled={alreadySelectedMaxComplements}
        />
      )}
    </div>
  );
}
